module.exports = {
    fr: {
        eyebrow: "Réservation confirmée",
        title: "Paiement effectué avec succès",
        subtitle: "Nous vous remercions pour votre confiance.",
        nextTitle: "Votre chauffeur vous appelle",
        next: "Vous allez prochainement recevoir un appel de votre chauffeur afin de préparer ensemble le déplacement.",
        contactTitle: "Une question ?",
        contact: "Écrivez-nous ou appelez-nous, nous vous répondons directement.",
        soon: "À très bientôt.",
        home: {
            label: "Revenir sur le site internet",
            link: "/"
        }
    },
    en: {
        eyebrow: "Booking confirmed",
        title: "Payment made successfully",
        subtitle: "We thank you for your confidence.",
        nextTitle: "Your driver will call you",
        next: "You will soon receive a call from your driver to prepare the trip together.",
        contactTitle: "Any questions?",
        contact: "Write or call us and we will answer you directly.",
        soon: "See you soon.",
        home: {
            label: "Return to the website",
            link: "/en/"
        }
    },
    ru: {
        eyebrow: "Бронирование подтверждено",
        title: "Оплата выполнена успешно",
        subtitle: "Мы благодарим вас за доверие.",
        nextTitle: "Водитель вам позвонит",
        next: "Вскоре вам позвонит водитель, чтобы вместе подготовиться к поездке.",
        contactTitle: "Есть вопросы?",
        contact: "Напишите или позвоните нам, мы ответим напрямую.",
        soon: "До скорого.",
        home: {
            label: "Вернуться на сайт",
            link: "/ru/"
        }
    }
};
